import { Route, Routes } from "react-router-dom";
import React, { useState, useMemo, Suspense, lazy } from "react";
import Loading from "./components/Loading";

const DataTable = lazy(() =>
  import("./homePage/components/DataTable/DataTable")
);
const CompanyForm = lazy(() => import("./EnterCompanyDataPage"));
const PageNotFound = lazy(() =>
  import("./PageNotFound/components/PageNotFound")
);
const LoginPage = lazy(() => import("./loginPage/LoginPage"));
const SignupPage = lazy(() => import("./signupPage/SignupPage"));
const HomePage = lazy(() => import("./homePage/components/HomePage"));
const ContactsPage = lazy(() => import("./homePage/components/ContactsPage"));
const Automations = lazy(() => import("./homePage/components/Automations/components/Automations"));

const AuthContext = React.createContext();
const RouterComponent = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const authContextValue = useMemo(
    () => ({
      isAuthenticated: isAuthenticated,
      setIsAuthenticated: setIsAuthenticated,
    }),
    [isAuthenticated, setIsAuthenticated]
  );
  return (
    <Suspense fallback={<Loading />}>
      <AuthContext.Provider value={authContextValue}>
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/home" element={<HomePage />}>
            <Route index path="" element={<DataTable />} />
            <Route path="contacts" element={<ContactsPage />} />
            <Route path="enter-data-manually" element={<CompanyForm />} />
            <Route path="automations" element={<Automations />} />
          </Route>
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </AuthContext.Provider>
    </Suspense>
  );
};

export default RouterComponent;
